/**
 * Variação do faturamento de um mês contra o mês anterior, por afiliado (ou produto). É o
 * "rastreamento de calor" da planilha do gestor, agora com regra fixa em vez de pintura à mão.
 */
export const TREND_STATUSES = [
    'up_strong',
    'up',
    'flat',
    'down',
    'down_strong',
    'zero',
    'new',
];
/** Limites da variação (fração): ±20% é sinal, ±50% é sinal forte. */
export const TREND_THRESHOLDS = {
    up: 0.2,
    upStrong: 0.5,
    down: -0.2,
    downStrong: -0.5,
};
export const NO_TREND = { ratio: null, status: null };
/** Status que pedem atenção: queda ou mês zerado depois de vender. */
export const ALERT_STATUSES = ['down', 'down_strong', 'zero'];
const isZero = (v) => Math.abs(v) < 0.005;
/**
 * @param current  valor do mês (nulo = nenhuma linha de relatório no mês)
 * @param previous valor do mês anterior (nulo = nenhuma linha)
 * @param factor   projeção de mês parcial: dias do mês ÷ dias cobertos (1 = mês completo)
 * @param partial  mês ainda incompleto: zero não vira alerta (as vendas podem só não ter chegado)
 */
export function computeTrend(current, previous, factor = 1, partial = false) {
    if (current === null)
        return NO_TREND;
    if (isZero(current)) {
        // Zerou depois de vender é sinal; zero atrás de zero (ou de nada) não é.
        if (partial)
            return NO_TREND;
        return previous !== null && previous > 0 ? { ratio: -1, status: 'zero' } : NO_TREND;
    }
    const cur = current * factor;
    if (previous === null || previous <= 0) {
        return cur > 0 ? { ratio: null, status: 'new' } : NO_TREND;
    }
    const ratio = (cur - previous) / previous;
    const status = ratio >= TREND_THRESHOLDS.upStrong
        ? 'up_strong'
        : ratio >= TREND_THRESHOLDS.up
            ? 'up'
            : ratio <= TREND_THRESHOLDS.downStrong
                ? 'down_strong'
                : ratio <= TREND_THRESHOLDS.down
                    ? 'down'
                    : 'flat';
    return { ratio, status };
}
/** Fator de projeção de um mês parcial (1 quando completo ou sem cobertura). */
export function projectionFactor(daysInMonth, daysCovered) {
    if (daysCovered <= 0 || daysCovered >= daysInMonth)
        return 1;
    return daysInMonth / daysCovered;
}
